import React from "react";
import { useTranslation } from "react-i18next";
import HelpSectionSliderSectionItemPure from "./help-section-slider-section-item.pure";
import HelpSectionSliderFaqItemPure from "./help-section-slider-faqs-item.pure";
import HelpSectionSliderVideosItemPure from "./help-section-slider-videos-item.pure";
// import { PostBlogPure } from "../../pures";
import "./help-section-slider.pure.css";
import { useEffect, useState } from "react";

const HelpSectionSliderPure = (props) => {
  const { t } = useTranslation();
  const {
    helpSection,
    helpSectionFirstsFaqs,
    helpSectionFirstVideo,
    helpSectionSelect,
    showHelpSection,
    showHelpSectionSelect,
    initializeHelpSection,
    toggleHelpSection,
    toggleHelpSectionQuestionAnswer,
    onSelectHelpSection,
    onClickReturnHelpSection,
    onClickNextHelpSection,
  } = props;
  
  // const [scrollY, setScrollY] = useState(0)
  
  const [scrollY, setScrollY] = useState(60)
  // const scrolling = () => {
  //   console.log('Esta haciendo scroll', window.scrollY)
  // }

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if(window.scrollY>60) {
        setScrollY(0)
      } else {
        setScrollY(60)
      }
    });
  }, [window.scrollY])
  

  return (
    <div className={`${initializeHelpSection ? "" : "helpSectionPanel hide"}`}>
      <div style={{marginTop: scrollY}}className={`helpSectionPanel ${showHelpSection ? "open" : ""}`}>
        {/* Header Verde */}
        <div className="helpSecionPanel-header">
          <span
            className="helpSecionPanel-header-icon"
            onClick={toggleHelpSection}
          >
            <i className="k-icon k-i-close k-i-x helpSecionPanel-header-icon-size" />
          </span>
          <p className="helpSecionPanel-header-title">
            {t("helpSection.YouNeedHelp")}
          </p>
        </div>

        {/* Div Section Content*/}
        {helpSectionSelect && showHelpSectionSelect ? (
          <div className="helpSecionPanel-content">
            {/* Div HelpSectionSelect - Nombre Seccion, Buttons: Menu, Siguiente sección */}
            <div>
              <div className="helpSectionSelect-contenct-div-title">
                <span className="helpSectionSelect-contenct-div-title-img">
                  <img
                    src={helpSectionSelect.icon}
                    width={16}
                    alt="icono de sección"
                  />
                </span>
                <p className="helpSectionSelect-content-title">
                  {helpSectionSelect.name}
                </p>
              </div>
              <div>
                <span
                  className="helpSectionSelect-content-button-menus"
                  onClick={onClickReturnHelpSection}
                >
                  {t("helpSection.sectionSelect.buttonMenu")}
                </span>
                <span
                  className="helpSectionSelect-content-button-menus"
                  onClick={() => {
                    onClickNextHelpSection(helpSectionSelect);
                  }}
                >
                  {t("helpSection.sectionSelect.buttonNextSection")}
                </span>
              </div>
            </div>

            {/* Div HelpSectionSelect - htmlBody from DB */}
            <div
              className="helpSectionSelect-content-div-htmlBoy"
              dangerouslySetInnerHTML={{ __html: helpSectionSelect.htmlBody }}
            />

            {/* Div HelpSectionSelect - Preguntas Frecuentes */}
            <div>
              <p className="helpSecionPanel-content-title">
                {t("helpSection.sectionSelect.faqs")}
              </p>
              {helpSectionSelect.helpSectionFaq.map((item, index) => (
                <HelpSectionSliderFaqItemPure
                  key={String(index)}
                  faq={item}
                  stateList={"selectedFaqs"}
                  toggleHelpSectionQuestionAnswer={
                    toggleHelpSectionQuestionAnswer
                  }
                />
              ))}
            </div>

            {/* Div HelpSectionSelect - Videos */}
            <div className="helpSecionPanel-content-div-blog">
              {helpSectionSelect.helpSectionVideos.map((item, index) => (
                <HelpSectionSliderVideosItemPure
                  key={String(index)}
                  video={item}
                />
              ))}
            </div>
          </div>
        ) : (
          <div className="helpSecionPanel-content">
            {/* Div HelpSection - "Explorar por sección" */}
            <div>
              <p className="helpSecionPanel-content-title">
                {t("helpSection.exploreSections")}
              </p>
              {helpSection.map((item, index) => (
                <HelpSectionSliderSectionItemPure
                  key={String(index)}
                  helpSection={item}
                  onSelectHelpSection={onSelectHelpSection}
                />
              ))}
            </div>

            {/* Div HelpSection - "Preguntas frecuentes" */}
            <div>
              <p className="helpSecionPanel-content-title">
                {t("helpSection.faqs")}
              </p>
              {helpSectionFirstsFaqs.map((item, index) => (
                <HelpSectionSliderFaqItemPure
                  key={String(index)}
                  faq={item}
                  stateList={"firstFaqs"}
                  toggleHelpSectionQuestionAnswer={
                    toggleHelpSectionQuestionAnswer
                  }
                />
              ))}
            </div>

            {/* Div HelpSection - "Explorar la sección de videos" */}
            <div className="helpSecionPanel-bottom-separator">
              <p className="helpSecionPanel-content-title">
                {t("helpSection.sectionSelect.explorSectionVideos")}
              </p>
              <div>
                <HelpSectionSliderVideosItemPure
                  video={helpSectionFirstVideo}
                />
              </div>
            </div>

            {/* <Grid
              xs={12}
              lg={4}
              md={12}
              sm={12}
              es={4}
              className="postBlog-newsSection"
            >
              <PostBlogPure {...props} />
            </Grid> */}
          </div>
        )}
      </div>
    </div>
  );
};
export { HelpSectionSliderPure as default };
